import ChartPanel from '/components/statistics/chart-panel'
import FilterBar from '/components/statistics/filter-bar'
import PageShell from '/components/statistics/page-shell'
import useClientStatistics from '/components/statistics/use-client-statistics'

const compactChartSetting = {
  yAxis: [{ label: 'count', width: 90 }]
}

const StatisticsInstalls = () => {
  const { loading, periodDays, setPeriodDays, selectableTemplates, statistics, templateId, setTemplateId } = useClientStatistics()

  return (
    <PageShell title="Statistics Installs" heading="Statistics - Installs">
      <div className='flex flex-col gap-5 mt-5 pb-20'>
        <FilterBar
          periodDays={periodDays}
          setPeriodDays={setPeriodDays}
          templateId={templateId}
          setTemplateId={setTemplateId}
          selectableTemplates={selectableTemplates}
          summaryItems={[
            { title: 'Apple Installs', value: statistics.extraTotals.appleInstalls },
            { title: 'Google Installs', value: statistics.extraTotals.googleInstalls }
          ]}
        />

        <ChartPanel
          title='Install trends by platform'
          description='Shows when passes were installed on Apple and Google devices during the selected period.'
          dataset={statistics.installTrend}
          xAxis={{ scaleType: 'band', dataKey: 'bucket_label' }}
          series={[
            { dataKey: 'apple_installs', label: 'Apple installs' },
            { dataKey: 'google_installs', label: 'Google installs' }
          ]}
          loading={loading}
          height={380}
          yAxis={compactChartSetting.yAxis}
        />
      </div>
    </PageShell>
  )
}

export default StatisticsInstalls
